import React from 'react';

import {
  Icon,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from '../styled';

type Props = {
  active: boolean;
  content: {
    title: string;
  };
  onToggle: { (): void };
};

const Fold = ({
  active,
  content,
  onToggle,
}: Props) => (
  <S.Fold>
    <S.Title
      active={active}
      onClick={onToggle}
    >
      <Icon
        size="16px"
        type={`fas fa-angle-${active ? 'down' : 'right'}`}
      />
      <Text size="18px">
        {content.title}
      </Text>
      {content.subTitle && (
        <Text
          size="14px"
          color="#121827"
        >
          {content.subTitle}
        </Text>
      )}
    </S.Title>
    {active && (
      <Flex
        width="100%"
        padding="0 0 0 20px"
        column
      >
        {typeof content.inner === 'function' ? content.inner() : content.inner}
      </Flex>
    )}
  </S.Fold>
);

export default Fold;
